export default {
  isPrint: false,
}
